import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    margin: 0,
    marginTop: 16,
    padding: '1rem 1.25rem',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    borderRadius: '0.5rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
  },

  description: {
    textAlign: 'left',
    fontFamily: 'Nunito',
    fontWeight: '400',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: '#191C1A',
  },

  tableBase: {
    width: '100%',
  },

  tableHeader: {
    '& th': {
      fontFamily: 'Nunito',
      fontWeight: '600',
      fontSize: '0.875rem',
      lineHeight: '2rem',
      textAlign: 'left',
      padding: '1rem',
      boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
    },
  },

  tableBody: {
    '& td': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.75rem',
      textAlign: 'left',
      padding: '1rem',
      boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
    },
  },

  tableNameSize: {
    width: '99%',
    padding: '0.25rem 1rem',
  },

  tableOthersSize: {
    width: '68%',
    padding: '0.25rem 1rem',
    alignItems: 'start',
    '& span': {
      textTransform: 'capitalize',
    },
  },

  tableActionSize: {
    width: '1%',
  },

  group: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: '0.5rem 0',
  },

  groupText: {
    marginLeft: '10px',
    margin: 0,
    padding: 0,
    fontFamily: 'Nunito !important',
    fontSize: '14px !important',
    lineHeight: '20px !important',
    fontWeight: '400 !important',
    maxWidth: '300px !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  text: {
    minWidth: '100px',
    maxWidth: '120px !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  subTitle: {
    opacity: 0.5,
    fontSize: '13px !important',
  },
}))

export { useStyles }
